"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Rate limiter function.
 *
 * @see https://medium.com/@pat_migliaccio/rate-limiting-throttling-consecutive-function-calls-with-queues-4c9de7106acc
 * @param {function} fn function to call.
 * @param {integer} wait interval between function calls.
 */
function limiter(fn, wait) {
  var isCalled = false,
      calls = [];

  var caller = function caller() {
    if (calls.length && !isCalled) {
      isCalled = true;
      calls.shift().call();
      setTimeout(function () {
        isCalled = false;
        caller();
      }, wait);
    }
  };

  return function () {
    calls.push(fn.bind.apply(fn, [this].concat(Array.prototype.slice.call(arguments))));
    caller();
  };
}

var _default = limiter;
exports.default = _default;